import { ToggleButton, ToggleButtonProps } from "@mui/material";
import { forwardRef } from "react";

export type SHToggleButtonProps = ToggleButtonProps;

export const SHToggleButton = forwardRef<
  HTMLButtonElement,
  SHToggleButtonProps
>((props, ref): JSX.Element => <ToggleButton {...props} ref={ref} />);
